/**
 * created by mgg
 *线索管理
 */
import React, {Component} from 'react';
import {Tabs, Button, Input, Row, Col, Modal, Form, message, Pagination, Upload} from 'antd';
import ManagementTable from "../../components/managementTable/ManagementTable";
import {UploadOutlined, PlusCircleOutlined} from '@ant-design/icons';
import UploadWall from "../../components/upload/UploadWall";
import {PIC_TYPE, VIDEO_TYPE, FILE_TYPE, ATTCHMENT_TYPE} from "../../constants";
// import ChunkUpload from "../../components/upload/ChunkUpload";
import "./ClueManagement.css";

const {TabPane} = Tabs;
const {Search} = Input;
const {confirm} = Modal;

export default class ClueManagement extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            detailVisible: false,
            backVisible: false,  //撤回
            delVisible:false,  //删除
            modalTitle: "",
            loading: false,
            previewImage: '',
            previewTitle: '',
            dataSource: [],
            imgList: [], //图片数据
            videoList: [],  //视频数据
            fileList: [],  //附件数据
            page: 1,
            page_size: 10,
            total: 0,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                {this.renderHeader()}
                {this.renderAddModal()}
                {this.renderDetailModal()}
                {this.renderBackModal()}
                {this.renderDelModal()}
            </div>
        )
    };


    //页头
    renderHeader() {
        return (
            <div style={{width: 1640, background: "#fff", opacity: 1, borderRadius: '5', margin: "0 auto"}}>
                <div style={{width: 1575, height: '100%', background: "#fff", margin: "0 auto"}}>
                    <Tabs defaultActiveKey="1" style={{height: 1000}}>
                        <TabPane tab="全部" key="1">
                            {this.renderContent()}
                        </TabPane>
                        <TabPane tab="已采用" key="2">
                            {this.renderContent()}
                        </TabPane>
                        <TabPane tab="已弃用" key="3">
                            {this.renderContent()}
                        </TabPane>
                    </Tabs>
                    <div>
                    </div>
                </div>
            </div>
        )
    };

    //表格
    renderContent() {
        const columns = [
            {
                title: '序号',
                dataIndex: 'id',
                key: 'id',
                align: 'center',
            },
            {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
                align: 'center',
            },
            {
                title: '修改时间',
                dataIndex: 'updateDate',
                key: 'updateDate',
                align: 'center',
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                render: (text, record) => {
                    let color = '';
                    if (record.status === '已采用') {
                        color = <div>
                             <span style={{
                                 width: 8,
                                 height: 8,
                                 background: "#F56C6C",
                                 borderRadius: "50%",
                                 opacity: 1
                             }}>
                            </span>
                            <span>已采用</span>
                        </div>
                    } else if (record.status === '已撤回') {
                        color = <div>
                             <span style={{
                                 width: 8,
                                 height: 8,
                                 background: "#89D069",
                                 borderRadius: "50%",
                                 opacity: 1
                             }}>
                            </span>
                            <span>已撤回</span>
                        </div>
                    } else if (record.status === '已提交') {
                        color = <div>
                             <span style={{
                                 width: 8,
                                 height: 8,
                                 background: "#0050B3",
                                 borderRadius: "50%",
                                 opacity: 1
                             }}>
                            </span>
                            <span>已提交</span>
                        </div>
                    }
                }
            },
            {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                align: 'center',
                render: (text, record) => (
                    <div>
                        <a type="primary" onClick={() => {
                            this.edit()
                        }} style={{marginRight: 10}}>编辑</a>
                        <a type="primary" onClick={() => {
                            this.watch()
                        }} style={{marginRight: 10}}>查看</a>
                        <a type="primary" onClick={() => {
                           this.setState({delVisible:true})
                        }} style={{marginRight: 10}}>删除</a>
                        <a type="primary" onClick={() => {
                            this.setState({backVisible: true})
                        }}>撤回</a>
                    </div>
                )
                /* render:(text,record)=>{
                     let statusText = '';
                         if(record.status === '已采用'){
                             statusText = <div>
                                  <a type="primary" onClick={()=>{this.watch()}} style={{marginRight:10}}>查看</a>
                             </div>
                         }else if(record.status === '已撤回'){
                             statusText = <div>
                                 <a type="primary" onClick={()=>{this.edit()}} style={{marginRight:10}}>编辑</a>
                                 <a type="primary" onClick={() => {this.setState({backVisible:true})}}>撤回</a>
                             </div>
                         }else{
                             statusText = <div>
                                 <a type="primary" onClick={()=>{this.watch()}} style={{marginRight:10}}>查看</a>
                                <a type="primary" onClick={() => {this.setState({backVisible:true})}}>撤回</a>
                             </div>
                         }
                 }*/
            },
        ];
        const dataSource = [];
        for (let i = 1; i <= 10; i++) {
            dataSource.push(
                {
                    key: i,
                    id: i,
                    title: '这是线索标题',
                    updateDate: '2021-4-16',
                }
            )
        }
        ;
        return (
            <div>
                <Row style={{marginTop: 15}}>
                    <Col span={12}>
                        <Button style={{background: "#0050B3", color: "#fff"}} onClick={() => {
                            this.add()
                        }}>新增线索</Button>
                    </Col>
                    <Col span={12}>
                        <Search placeholder="请输入关键词" onSearch={this.onSearch} style={{width: 200, float: "right"}}/>
                    </Col>
                </Row>
                <div>
                    <div style={{marginTop: 15, height: "1000px"}}>
                        <ManagementTable
                            columns={columns}
                            dataSource={dataSource}
                        />
                    </div>
                </div>
            </div>
        )
    };


    //新增和编辑
    renderAddModal() {
        return (
            <div>
                <Modal
                    title={this.state.modalTitle}
                    visible={this.state.visible}
                    onOk={() => this.save()}
                    onCancel={() => {
                        this.setState({visible: false})
                    }}
                    centered={true}
                    width={1000}
                    footer={
                        <div style={{textAlign: 'center'}}>
                            <Button onClick={() => this.setState({visible: false})}
                                    style={{marginRight: 20}}>暂存</Button>
                            <Button style={{background:"#0050B3",color:"#fff"}} onClick={() => this.setState({visible: false})}>提交</Button>
                        </div>
                    }
                >
                    <Form labelCol={{span: 5}} wrapperCol={{span: 14}} style={{textAlign: "center"}}>
                        <Form.Item label="线索标题" required>
                            <Input placeholder="请输入标题" style={{width: 500, background: "rgba(0, 80, 179, 0.04)"}}/>
                        </Form.Item>
                        <Form.Item label="联系人" required style={{marginTop: 10}}>
                            <Input placeholder="请输入联系人" style={{width: 500, background: "rgba(0, 80, 179, 0.04)"}}/>
                        </Form.Item>
                        <Form.Item label="联系电话" style={{marginTop: 10}}>
                            <Input placeholder="请输入联系电话" style={{width: 500, background: "rgba(0, 80, 179, 0.04)"}}/>
                        </Form.Item>
                        <Form.Item label="线索内容" style={{marginTop: 10}}>
                            <Input placeholder="请输入线索内容" style={{width: 500, background: "rgba(0, 80, 179, 0.04)"}}/>
                        </Form.Item>
                        <Form.Item label="线索图片">
                            {this.renderPicture()}
                        </Form.Item>
                        <Form.Item label="线索视频">
                            {this.renderVideo()}
                        </Form.Item>
                        <Form.Item label="线索附件" style={{textAlign: "left"}}>
                            {this.renderAttachment()}
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        )
    }

    //线索详情
    renderDetailModal() {
        return (
            <div>
                <Modal
                    title="线索详情"
                    visible={this.state.detailVisible}
                    onCancel={() => {
                        this.setState({detailVisible: false})
                    }}
                    centered={true}
                    width={1300}
                    footer={null}
                >
                    <div style={{
                        width: 1000,
                        height: 128,
                        background: "rgba(0, 80, 179, 0.04)",
                        border: "1px solid rgba(0, 80, 179, 0.0784313725490196)",
                        opacity: 1,
                        margin: "0 auto",
                    }}>
                        <div style={{marginLeft: 10, marginBottom: 10, marginTop: 10}}>已采用!</div>
                        <div style={{marginLeft: 10}}>这是采用原因。</div>
                        <div style={{marginLeft: 10, marginTop: 10}}>
                            <span>批注时间：</span>
                            <span style={{marginLeft: 30}}>审批人：</span>
                        </div>
                    </div>
                    <div style={{width: 800, margin: "0 auto"}}>
                        <div className="info" style={{marginTop: 20}}>
                            <span className="font">线索标题：</span>
                            <span></span>
                        </div>
                        <div className="info">
                            <span className="font">联系人：</span>
                            <span></span>
                        </div>
                        <div className="info">
                            <span className="font">联系电话：</span>
                            <span></span>
                        </div>
                        <div className="info">
                            <span className="font">联系内容：</span>
                            <span></span>
                        </div>
                        <Row>
                            <Col span={3} className="font">线索图片：</Col>
                            <Col style={{
                                width: 200,
                                height: 150,
                                borderRadius: 5,
                                border: "1px dashed #707070",
                                background: "#fff",
                                opacity: 1,
                                float: "left",
                            }}
                                 span={6}
                            >
                            </Col>
                        </Row>
                        <Row style={{marginTop: 15}}>
                            <Col span={3} className="font">线索视频：</Col>
                            <Col style={{
                                width: 200,
                                height: 150,
                                borderRadius: 5,
                                border: "1px dashed #707070",
                                background: "#fff",
                                opacity: 1,
                                float: "left",
                            }}
                                 span={6}
                            >
                            </Col>
                        </Row>
                        <div className="info">
                            <span className="font">线索附件：</span>
                            <span></span>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }

    //撤回
    renderBackModal() {
        return (
            <Modal
                title="操作"
                style={{top: 20}}
                visible={this.state.backVisible}
                onOk={() => this.setState({backVisible: false})}
                onCancel={() => this.setState({backVisible: false})}
                centered={true}
                width={400}
                height={200}
                footer={
                    <div style={{textAlign: "center"}}>
                        <Button onClick={() => this.setState({backVisible: false})}>取消</Button>
                        <Button onClick={() => {this.backout()}} style={{background: "#0050B3", color: "#fff"}}>确定</Button>
                    </div>
                }
            >
                <div>是否确定撤回？</div>
            </Modal>
        )
    }

    //删除
    renderDelModal() {
        return (
            <Modal
                title="操作"
                style={{top: 20}}
                visible={this.state.delVisible}
                onOk={() => this.setState({delVisible: false})}
                onCancel={() => this.setState({delVisible: false})}
                centered={true}
                width={400}
                height={200}
                footer={
                    <div style={{textAlign: "center"}}>
                        <Button onClick={() => this.setState({delVisible: false})}>取消</Button>
                        <Button onClick={() => {
                            this.delete()
                        }} style={{background: "#0050B3", color: "#fff"}}>确定</Button>
                    </div>
                }
            >
                <div>是否确定删除？</div>
            </Modal>
        )
    }

    //线索图片
    renderPicture() {
        return (
            <div
               /* style={{
                width: 200,
                height: 150,
                background: "rgba(0, 80, 179, 0.04)",
                border: "1px solid rgba(0, 80, 179, 0.0784313725490196)",
                opacity: 1,
                borderRadius: 5,
                marginTop: 10,
                marginLeft: 24
            }}*/
            >
                <UploadWall
                   /* style={{
                        width: 35,
                        height: 35,
                        background: "0050B3",
                        borderRadius: "50%",
                        opacity: 1,
                        marginLeft: 80,
                        marginTop: 49,
                        cursor: "pointer",
                        backgroundSize: 'auto',
                        backgroundImage: 'url(images/icon_add.png)',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}*/
                    accept={"." + PIC_TYPE.join(",.")}
                    multiple={true}
                    // action="/cm-sites-pms/index/uploadFile"
                    listType="picture-card"
                    fileList={this.state.imgList}
                    icons={["eye", "download", "delete"]}
                    uploadBtnName={"点击上传"}
                    onPreview={this.handlePreviewImg}
                    onChange={this.handleChangeImg}
                    onRemove={this.handleRemoveImg}
                    showUploadBtn={this.state.fileList.length < 8 ? true : false}
                />
            </div>
        )
    }

    //线索视频
    renderVideo() {
        return (
            <div style={{
                width: 200,
                height: 150,
                background: "rgba(0, 80, 179, 0.04)",
                border: "1px solid rgba(0, 80, 179, 0.0784313725490196)",
                opacity: 1,
                borderRadius: 5,
                marginTop: 10,
                marginLeft: 24
            }}
            >
                <UploadWall
                    style={{
                        width: 35,
                        height: 35,
                        background: "0050B3",
                        borderRadius: "50%",
                        opacity: 1,
                        marginLeft: 80,
                        marginTop: 49,
                        cursor: "pointer",
                        backgroundSize: 'auto',
                        backgroundImage: 'url(images/icon_add.png)',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}
                    accept={"." + VIDEO_TYPE.join(",.")}
                    multiple={true}
                    // action="/cm-sites-pms/index/uploadFile"
                    listType="picture-card"
                    fileList={this.state.videoList}
                    uploadBtnName={"点击上传"}
                    onPreview={this.handlePreviewVideo}
                    onChange={this.handleChangeVideo}
                    onRemove={this.handleRemoveVideo}
                />
            </div>
        )
    }

    //线索附件
    renderAttachment() {
        return (
            <div>
                <UploadWall
                    style={{marginLeft: 24}}
                    accept={"." + ATTCHMENT_TYPE.join(",.")}
                    multiple={true}
                    action="/cm-sites-pms/index/uploadFile"
                    listType="list"
                    // customRequest={new ChunkUpload({
                    //    /* checkFileURL: "/cm-sites-" + process.env.REACT_APP_NAME + "/index/checkFile",*/
                    // }).start}
                    // icons={["download", "delete"]}
                    fileList={this.state.fileList}
                    uploadBtnName={"上传附件"}
                    onChange={this.handleChangeFileList}
                    onRemove={this.handleRemoveFileList}
                />
            </div>
        )
    }

    //上传图片
    handleChangeImg = ({imgList}) => {
        /*  if (fileList.length > 8) {
              message.info('最多上传8张');
              return;
          }
          if (file.status === "done") {
              file.response.interviewId = this.props.data ? this.props.data.id : 0;
              let newFileList = fileList.map(item => {
                  item.url = item.response.url;
                  item.path = item.response.url;
                  item.resourceId = item.uid;
                  item.type = 'IMAGE';
                  return item;
              });
              this.setState({fileList: newFileList});
          }*/
        this.setState({imgList});
    };

    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };

    handlePreviewImg = async file => {
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }
        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
        });
    };

    handleRemoveImg = async file => {
        /* delResource(this.props.data.id, file.resourceId);
         this.setState(prevState => {
             let fileList = prevState.fileList.filter(item => {
                 return item.uid !== file.uid
             });
             return {
                 fileList
             }
         });*/
    };


    //上传视频
    handleChangeVideo = ({videoList}) => {
        this.setState({videoList});
    };
    handleRemoveVideo = async file => {

    };


    //上传附件
    handleChangeFileList = ({fileList}) => {
        this.setState({fileList});
    };
    handleRemoveFileList = async file => {

    };


    //新增
    add() {
        this.setState({
            visible: true,
            modalTitle: '新增线索',
        })
    };

    //编辑
    edit() {
        this.setState({
            visible: true,
            modalTitle: '编辑线索',
        })
    };

    //保存
    save() {
        this.setState({
            addVisible: false,
        })
    };

    //查看(线索详情）
    watch() {
        this.setState({
            detailVisible: true,
        })
    }

    //删除
    delete(){
        this.setState({
            delVisible: false,
        })
    }
   /* delete() {
        confirm({
            content: '是否确定删除 ?',
            centered: 'centered',
            okText: '确认',
            cancelText: '取消',
            onOk() {
            },
            onCancel() {
            },
        })
    }*/

    //撤回
    backout() {
        this.setState({
            backVisible: false,
        })
    }

    /* backout() {
         confirm({
             content: '是否确定撤回 ?',
             centered: 'centered',
             okText: '确认',
             cancelText: '取消',
             onOk() {
             },
             onCancel() {
             },
         })
     }*/

}